import { render, staticRenderFns } from "./create-registry-form.vue?vue&type=template&id=07f7924a&scoped=true&"
import script from "./create-registry-form.ts?vue&type=script&lang=ts&"
export * from "./create-registry-form.ts?vue&type=script&lang=ts&"
import style0 from "./create-registry-form.scss?vue&type=style&index=0&id=07f7924a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f7924a",
  null
  
)

export default component.exports